import { useTranslation } from 'react-i18next';
import Pill from '../Pill/Pill';
import { CommissionContractOfferDto } from '../../api/CommissionContractOffersAPI';

interface CommissionOfferCardProps {
  offer: CommissionContractOfferDto;
  onEdit: () => void;
}

export default function CommissionOfferCard({ offer, onEdit }: CommissionOfferCardProps) {
  const { t } = useTranslation();
  const hasDropFee = (offer.dropFeePrice ?? 0) > 0;
  const salonSplit = offer.salonSplitPercentage;
  const brideSplit = offer.brideSplitPercentage;

  return (
    <div
      className="flex items-center flex-wrap gap-2 cursor-pointer"
      onClick={onEdit}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onEdit();
        }
      }}
      role="button"
      tabIndex={0}
    >
      <div className="text-lg font-bold">{offer.name}</div>
      <Pill
        text={
          hasDropFee
            ? t('bookings.listing.paid') || 'Paid'
            : t('bookings.listing.free') || 'Free'
        }
        color={hasDropFee ? 'blue' : 'green'}
      />
      {salonSplit != null && brideSplit != null && (
        <Pill text={`${salonSplit}/${brideSplit}`} color="grey" />
      )}
    </div>
  );
}
